/*=========================================================================================
  File Name: module-usertax-state.js
  Description: UserTax Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import OrganizationsUnit from '@/model/OrganizationsUnit.js';
export default {
	//Danh sách phòng ban ở phần chọn nhanh chi nhánh làm việc
	OrganizationUnits: [],
	//Danh achs phòng ban trong cơ cấu tổ chức
	Organizations: [],
	OrganizationWorking: {},
	SubscriberWorking: {},
	organizationGuide: false,
	hiddenTips: false,
	// Organization: new OrganizationsUnit(),
	//Tất cả danh sách phòng ban dạng flat
	AllOrganizations: [],
	//Tất cả danh sách phòng ban dạng tree, làm việc với các combo export, lọc phần auditlogs
	AllTreeOrganizations: [],
	// Danh sách cơ cấu tổ chức không cần quyền
	FullTreeOrganizations: [],
	viewTourGuide: false,
	ShowPaymentWarnings: [],
	//Đã thực hiện show kết nối CQT với các chi nhánh phòng ban
	ShowConnectTaxaxions: [],
	// Đã thực hiện show thông báo đăng nhập kết nối cơ quan thuế hay chưa
	IsShowConnectTax: false,
	ShowLostConnectTaxaxion: [],
	IsShowLostConnectTaxaxion: false,
	IsShowInvoiceRiskBySupplier: false
};
